import AwsApi from '../Api'

// Each response belongs to a route and a generation of its loading operation.
// Invalidating a generation leaves network requests alone but prevents stale writes.
export default {
    created() {
        this._readRequests = { disposed: false, versions: {} }
    },
    beforeUnmount() {
        this._readRequests.disposed = true
    },
    methods: {
        invalidateReads(scope) {
            const versions = this._readRequests.versions
            versions[scope] = (versions[scope] || 0) + 1
        },
        captureRead(scope = 'page') {
            const state = this._readRequests
            const version = state.versions[scope] || 0
            const pageVersion = state.versions.page || 0
            const path = this.$route.fullPath
            return () => !state.disposed && this.$route.fullPath === path &&
                (state.versions.page || 0) === pageVersion &&
                (state.versions[scope] || 0) === version
        },
        async loadReadList(field, query, resultKey, variables, scope = 'page') {
            const isCurrent = this.captureRead(scope)
            if (!isCurrent()) return
            const items = []
            let nextToken = variables.nextToken
            do {
                const response = await AwsApi.graphql({
                    query,
                    variables: { ...variables, nextToken }
                }, this)
                if (!isCurrent() || !response) return
                const page = response.data[resultKey]
                items.push(...page.items)
                nextToken = page.nextToken
            } while (nextToken)
            this[field] = items
        }
    }
}
